// extracted by mini-css-extract-plugin
export default {"progressBar":"my-john-lewis-full-screen_progressBar__6281f","container":"my-john-lewis-full-screen_container__7e219"};